<div [ngClass]="{locked: isLocked}" data-test="news-entry-wrapper">
  <div class="small" data-test="news-entry-pub-date">{{newsEntry.pubDate | date}}</div>
  @if (!!newsEntry.link) {
    <a [href]="newsEntry.link" class="link-icon-text"
      data-test="news-entry-link" target="_blank">
      <span class="library-bekb-icon-font icon-link-extern white"></span>
    {{newsEntry.headline}}</a>
  } @else {
    @if (isLocked) {
      <div class="locked-entry">
        <span class="locked-headline" data-test="news-entry-locked-headline">{{newsEntry.headline}}</span>
        <div class="unlock-link">
          <a [routerLink]="['news', timestamp]" data-test="news-entry-link">AWP freischalten</a>
        </div>
      </div>
    } @else {
      <a [routerLink]="['news', timestamp]" data-test="news-entry-link">{{newsEntry.headline}}</a>
    }
  }

</div>
